import { IStateSliceDefaults, StateSliceName } from '../store.models';

import { Sport, ISportStateModel } from './sport.models';

export const sportStateDefaults: IStateSliceDefaults<ISportStateModel> = Object.freeze({
    sliceName: StateSliceName.SPORT,
    defaults: {
        currentSport: undefined,
        sportConfig: undefined
    }
});

/**
 * Type guard to determine if something is a valid sport
 * @param value
 * @returns
 */
export const isSport = (value: unknown): value is Sport => {
    return Object.values(Sport).includes(value as Sport);
};
